// Auth Handlers
export var AUTH_TOKEN_COOKIE_NAME = "CAT";
export var AUTH_TOKEN_EXPIRY_COOKIE_NAME = "CAT_EXP";
export var AUTH_COOKIE_EXPIRY_IN_HOURS = 1; // Blocked Account Page

export var CATCH_LOGO_URL = "https://s.catch.com.au/static/catch/images/logo-83d9b21199.svg";
export var TERMS_AND_CONDITIONS_URL = "/terms";
export var CUSTOMER_SUPPORT_URL = "https://help.catch.com.au/s/articles?&catName=My_Account"; // Auth Refresh Hook

export var REFRESH_TOKEN_ENDPOINT = "/auth_refresh";